// extracted by mini-css-extract-plugin
export var statItem = "_is-1";
export var statsRow = "_is-0";